<section
  class="custom-container"
  [ngStyle]="{ '--flex-direction': flexDirection }"
>
  <div class="right-container">
    <img
      class="w-36 -mb-5 lg:-mb-0 lg:w-48 aspect-video object-contain"
      src="../../../assets/icon/logo.svg"
      alt="Irani-Expert"
      alt="logo"
      width="50px"
      height="40px"
      loading="lazy"
    />
    <ng-container *ngIf="!changingPassword">
      <app-switch
        (output)="changeView()"
        [activeView]="view"
        [items]="switchItems"
      ></app-switch>
      <div class="w-full max-w-[268px]" [smoothHeight]="changed">
        <div>
          <app-signup
            [refralCode]="refralCode"
            (changingView)="changeViewFromSigup()"
            *ngIf="view == 'sign-up'"
          />
          <app-login
          *ngIf="view == 'login'"
          (changePassword)="changePasswordStatus($event)"
          (changingView)="changeViewFromLogin()"
          />
        </div>
      </div>
    </ng-container>
    <ng-container *ngIf="changingPassword">
      <div class="w-full" [smoothHeight]="changed">
        <div>
          <app-forget-password
            (changePassword)="changePasswordStatus($event)"
          />
        </div>
      </div>
    </ng-container>
  </div>
  <div *ngIf="this.flexDirection == 'row'" class="left-container">
    <!-- <app-lottie class="self-center" [config]="lottieConfig" /> -->
    <img src="../../../assets/img/auth.png" alt="welcome-iraniexpert" class="object-contain" loading="lazy"/>
  </div>
</section>
